import { DateHelpers } from './date';
import { NameHelpers } from './name';
import { Utils } from './utils';

export const Helpers = {
  DateHelpers: new DateHelpers(),
  NameHelpers: new NameHelpers(),
  Utils: new Utils(),
};
